import * as consts from "../consts";
import axios from "axios";

function handleError(exception, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-BUILDER:", exception);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_ERROR,
      },
      dispatch
    );
  }
}

function handleSuccess(response, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-BUILDER:", response);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_SUCCESS,
      },
      dispatch
    );
  }
}

function getHTTPHeaders(getAccessTokenSilently) {
  return new Promise((resolve) => {
    if (getAccessTokenSilently) {
      getAccessTokenSilently()
        .then((token) => {
          let options = token
            ? { headers: { Authorization: `Bearer ${token}` } }
            : {};
          console.log(options);
          resolve(options);
        })
        .catch(() => {
          resolve({});
        });
    } else {
      resolve({});
    }
  });
}

export function addAlert(alert, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_ADD_ALERT,
      payload: alert,
    });
    resolve();
  });
}

export function dismissAlert(dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_DISMISS_ALERT,
    });
    resolve();
  });
}

export function setBusy(busy, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_BUSY,
      payload: busy,
    });
    resolve();
  });
}

export function updateCart(cart, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_CART,
      payload: cart,
    });
    handleSuccess(null, `Successfully added item to cart`, dispatch);
    resolve();
  });
}

export function getProfile(getAccessTokenSilently, dispatch) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      axios
        .get(`${consts.SERVICE_URL}/Profile`, options)
        .then((response) => {
          let profile = response.data;
          dispatch({
            type: consts.ACTION_INITIALIZE_PROFILE,
            payload: profile,
          });
          resolve(profile);
        })
        .catch((exception) => {
          handleError(exception, `Unable to retrieve profile`, dispatch);
          reject(exception);
        });
    });
  });
}

export function getCardImageGroupings(getAccessTokenSilently, dispatch) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      axios
        .get(`${consts.SERVICE_URL}/Purchase/cardimagegroups`, options)
        .then((response) => {
          let cardImageGroupings = response.data;
          cardImageGroupings.groups = cardImageGroupings.groups.sort(function (
            a,
            b
          ) {
            if (b.displayOrder > a.displayOrder) {
              return -1;
            }
            if (b.displayOrder > a.displayOrder) {
              return 1;
            }
            if (b.displayName > a.displayName) {
              return -1;
            }
            if (b.displayName > a.displayName) {
              return 1;
            }
            return 0;
          });
          console.log(cardImageGroupings);

          cardImageGroupings.groups = cardImageGroupings.groups.filter(
            (value, index, self) =>
              index ===
              self.findIndex(
                (t) => t.cardImageGroupingId === value.cardImageGroupingId
              )
          );

          resolve(cardImageGroupings);
        })
        .catch((exception) => {
          handleError(
            exception,
            `Unable to retrieve card image groupings`,
            dispatch
          );
          reject(exception);
        });
    });
  });
}

export function getCardImages(groupingID, getAccessTokenSilently, dispatch) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      axios
        .get(`${consts.SERVICE_URL}/Purchase/cardimages/${groupingID}`, options)
        .then((response) => {
          let cardImages = response.data;
          resolve(cardImages);
        })
        .catch((exception) => {
          handleError(
            exception,
            `Unable to retrieve card images for grouping ${groupingID}`,
            dispatch
          );
          reject(exception);
        });
    });
  });
}
